'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;
// import { Helper } from 'helpers/support';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Images = require('helpers/Images');

var _Images2 = _interopRequireDefault(_Images);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VoucherFilterBar = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(VoucherFilterBar, _Component);

  function VoucherFilterBar(props) {
    (0, _classCallCheck3.default)(this, VoucherFilterBar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (VoucherFilterBar.__proto__ || (0, _getPrototypeOf2.default)(VoucherFilterBar)).call(this, props));

    _this.onHideFilter = function () {
      _this.setState({ showFilter: false });
    };

    _this.state = {
      showFilter: false
    };
    return _this;
  }

  (0, _createClass3.default)(VoucherFilterBar, [{
    key: 'onShowFilter',
    value: function onShowFilter() {
      this.setState({ showFilter: true });
    }
  }, {
    key: 'onChooseFilter',
    value: function onChooseFilter(voucherType) {
      this.props.changeVoucherFilter(voucherType);
      switch (voucherType) {
        case 'Ưu đãi 5 sao':
          this.onHideFilter();
          this.props.history.push('/uu-dai-5-sao');
          break;
        case 'Ưu đãi của tôi':
          this.onHideFilter();
          this.props.history.push('/uu-dai-toi');
          break;
        // case 'Dịch vụ tại nhà':
        //   this.onHideFilter();
        //   this.props.history.push('/dich-vu-tai-nha');
        //   break;
        case 'Ưu đãi trải nghiệm':
          this.onHideFilter();
          this.props.history.push('/uu-dai-trai-nghiem');
          break;
        default:
          this.onHideFilter();
          break;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          voucherFilters = _props.voucherFilters,
          voucherFilterChosen = _props.voucherFilterChosen,
          route = _props.route,
          className = _props.className;
      var showFilter = this.state.showFilter;

      var icon = void 0;
      if (route.path === 'uu-dai-trai-nghiem') {
        icon = _Images2.default.voucher.noStarFilterIcon;
      } else if (route.path === 'uu-dai-5-sao') {
        icon = _Images2.default.voucher.fiveStarFilterIcon;
      } else if (route.path === 'uu-dai-toi') {
        icon = _Images2.default.voucher.myVoucherFilterIcon;
      }
      // } else if (route.path === 'dich-vu-tai-nha') {
      //   icon = Images.voucher.homeServiceFilterIcon;
      // }
      var styles = require('./VoucherFilterBar.scss');
      return _react2.default.createElement(
        'div',
        { style: { width: '100%' } },
        _react2.default.createElement(
          'div',
          {
            className: styles.filterSearch + ' ' + className,
            onClick: function onClick() {
              return _this2.onShowFilter();
            }
          },
          _react2.default.createElement(
            'div',
            {
              style: {
                flexDirection: 'row',
                display: 'flex',
                alignItems: 'center'
              }
            },
            _react2.default.createElement('img', { src: icon, className: styles.iconFilter }),
            _react2.default.createElement(
              'div',
              { className: styles.textFilter },
              voucherFilterChosen
            )
          ),
          _react2.default.createElement('i', { className: 'fa fa-sort-desc' })
        ),
        _react2.default.createElement(
          _components.SlideCustom,
          { show: showFilter, onHide: function onHide() {
              return _this2.onHideFilter();
            } },
          voucherFilters && voucherFilters.map(function (item, i) {
            return _react2.default.createElement(
              'div',
              {
                key: i,
                className: styles.slideCustom,
                onClick: item !== voucherFilterChosen ? function () {
                  return _this2.onChooseFilter(item);
                } : function () {}
              },
              item,
              item === voucherFilterChosen ? _react2.default.createElement('img', {
                className: styles.iconRadio,
                src: _Images2.default.payment.checked,
                alt: ''
              }) : _react2.default.createElement('img', {
                className: styles.iconRadio,
                src: _Images2.default.payment.unChecked,
                alt: ''
              })
            );
          })
        )
      );
    }
  }]);
  return VoucherFilterBar;
}(_react.Component), _class.propTypes = {
  className: _react.PropTypes.string,
  history: _react.PropTypes.object,
  route: _react.PropTypes.object,
  voucherFilters: _react.PropTypes.array,
  voucherFilterChosen: _react.PropTypes.string,
  changeVoucherFilter: _react.PropTypes.func
}, _temp);
exports.default = VoucherFilterBar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Reward/VoucherFilterBar.js
// module id = 1634
// module chunks = 0